// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown--2zCS4","resultItem":"resultItem--22GKi"};